/*LOCAL PRE*/
// export const environment = {
//    // identityserver4Url: 'https://mojito-pre-identity.azurewebsites.net/',
//   identityserver4Url: 'https://sso.mojito360.com/',
//   redirect_uri: '/account/auth-callback',
//   api: "https://inn-api-mojito360.vercel.app",
//   apiBot: "https://inn-api-mojito360.vercel.app",
//   apiMojito: "https://localhost:44301/api",
//   apiComercial: "http://localhost:8000/api/v1",
//   azureTrigger: "azureTrigger",
//   userAdmin: ['lfernandez'],
//   // TODO: Reemplazar apiKey y eliminar de aqui
//   apiKey: 'V0KDLTPL4elSbz0yd5BWA1wRiw2hPPSrfE7ejrWqufcvOihBQFYbwH2KNZhOCFco2Arg9c2m7GWwmZt3ixEtjpwB0eujm6Bj5JoU',
//   allowedOrigins: ['http://localhost:4200']
// };

/*LOCAL PRO*/
export const environment = {
  identityserver4Url: 'https://sso.mojito360.com/',
  redirect_uri: '/account/auth-callback',
  api: "https://inn-api-mojito360.vercel.app",
  apiBot: "https://inn-api-mojito360.vercel.app",
  apiGreen: "/apiGreen",
  apiOdata: "/apiOdata",
  apiMojito: "/apiMojito",
  apiComercial: "/apiComercial",
  azureTrigger: "/azureTrigger",
  userAdmin: ['julgarcia@mojito360.com', 'lfernandez'],
  // TODO: Reemplazar apiKey y eliminar de aqui
  apiKey:
    'SZXNi9Vtu1BtRQ4pmtIkngYSDp8KiUGXJggFhRwLJ4jjmZjccj3eG7HgVlJ4NPkZzsxfgguCheibGJ6wngkkV6QBl1j6By4M6tJJ',
  allowedOrigins: ['https://app.mojito360.com'],
};
